import { Component, Input, OnInit } from '@angular/core';
import { ILayoutSettings, IPageContent } from '@app/feature/store-editor/components/layout/store-editor.interface';
import { CommonService } from '@app/feature/store-editor/services/common.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.css']
})
export class CTAComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;
  isStoreAdmin = localStorage.getItem('role') == "StoreAdmin" ||  localStorage.getItem('role') === 'StoreOwner' ||  localStorage.getItem('role') === 'StoreStaffMember';
  viewOnly = true;
  constructor(public cs: CommonService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.data.subscribe(data => {
      this.viewOnly = data.viewOnly != undefined ? data.viewOnly : true;
    });
  }

  ngOnInit() {
  }

  fixUrl(link: string) {   
    if (link.indexOf('http:') !== 0 && link.indexOf('https:') !== 0) {
      return 'http://' + link;
    }
  }
}
